export default "__VITE_ASSET__j$IhXLvp__"